export const AUTH_STORE_KEY = 'AUTH_DATA';
export const GRAPHQL_HOST = process.env.REACT_APP_GRAPHQL_BASE?.replace('graphql', '');
